// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, ReactNode, useContext, useEffect,
    useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import cn from 'classnames';
// @ts-ignore
import {get_country_object} from '/util/country.js';
import {Proxy_type, t_generated_proxy, t_order, t_zone_group}
    from '../../../../hola/pub/ui/pro/cp/orders';
import {convert_byte_to_gb, date_fmt, get_group_usage_info,
    get_payment_renew_url, get_usage_data,
    get_usage_info, get_visible_actions,
    i_sorting_state,
    is_group_expired,
    is_type_with_manual_proxies,
    order_has_renew_error,
    use_active_orders,
    use_disappear,
    use_sorting} from './utils';
import {Button} from '../../../../hola/pub/lib/button';
import {t_countries} from '../../lib/use_dashboard_data';
import {Action_menu} from './action_menu/action_menu';
import Icon_gift from '../../img/icons/24/gift.svg';
import Icon_chevron_down from '../../../../hola/pub/img/svg/icon/chevron_down.svg';
import Icon_trash_filled from '../../img/icons/24/trash_filled.svg';
import Icon_free_full from '../../img/dashboard/free_full2.svg';
import Icon_extra_one from '../../img/dashboard/extra_one.svg';
import Icon_extra_mid from '../../img/dashboard/extra_mid.svg';
import Icon_free_proxy_ready from '../../img/dashboard/free_proxy_ready.svg';
import Icon_freeze from '../../img/icons/24/freeze.svg';
import Icon_close16 from '../../img/icons/16/close.svg';
import Icon_close24 from '../../../../oculus/pub/img/icons/24/close.svg';
import {Modal} from '../../../../hola/pub/lib/modal';
import {Settings_context, use_theme} from '../../../../hola/pub/settings_ctx';
import etask from 'zetask';
import {Flag} from '../../../../hola/pub/lib/flag';
import {Pie_chart} from '../toolip/pie_chart';
import {ONBOARD_EVENTS, use_onboarding} from '../onboarding/onboarding';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import {perr} from 'hola_pub_util';
import {Skeleton_loader} from './skeleton_loader';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import {use_debug_ui} from '../../../../hola/pub/lib/debug';
// @ts-ignore
import {Tooltip} from '../../../../hola/pub/lib/tooltip';
import Icon_copy from '../../../../oculus/pub/img/icons/16/copy_line.svg';
import Icon_check from '../../../../oculus/pub/img/icons/16/check.svg';
import {Usage_charges_modal} from './additional_usage_charges';
import {LintHTMLDialogElement, Popup} from '../popup/popup';
import {Subscr_expiration} from '../../ui/dashboard/subscr_expiration/subscr_expiration';
import {www_hola} from 'hola_opt';
import styles from './plan_table.module.less';
import {api} from '../../lib/api';
import {use_etask} from '../../../../hola/pub/lib/use_etask';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {Maybe_kyc_subtitle} from './kyc/kyc';
import {use_app_context} from '../../lib/app_context';
import storage from '/util/storage.js';

interface i_visible_actions_params {
    config_list?: boolean;
    generate?: boolean;
    update_payment?: boolean;
    buy_new?: boolean;
}
type t_render_order_bw_info =
    (item: t_order, u?, is_extra?: boolean)=>React.ReactNode;
type t_render_group_bw_info = (item: t_zone_group, u?)=>React.ReactNode;
interface i_table_plan_props {
    type: Proxy_type;
    items?: t_order[];
    title: string | React.ReactNode;
    countries?: t_countries;
    orders_count?: number;
    is_free_zone_creating?: boolean;
    need_login?: ()=>void;
    with_onboarding?: boolean;
    active?: t_order;
    toggle_active?: (item: t_order)=>void;
    hide_actions?: boolean;
    hide_actions_col?: boolean;
    enable_sorting?: boolean;
    wrapper_cn: string;
    show_config_caption?: string;
    show_order_token?: boolean;
    buttons?: React.ReactNode;
    show_recently_expired?: boolean;
    get_visible_action?: (order: t_order)=> i_visible_actions_params;
    render_plan_popup_actions?: (item: t_order)=>React.ReactNode;
    render_bandwidth_info?: t_render_order_bw_info;
    render_usage_info?:
        (item: t_order, show_loader: boolean)=>React.ReactNode;
    render_subscr_end?: (item: t_order)=>React.ReactNode;
    update_payment?: (item: t_order)=>void;
}

const New_badge = ()=>{
    return <div className={cn(styles.row_badge, styles.new_badge)}>NEW</div>;
};

const Free_badge = ()=>{
    return <div className={cn(styles.row_badge, styles.free_badge)}>
      <Icon_gift width={16} height={16}/>
    </div>;
};

interface sortable_header {
    content: string | React.ReactNode;
    field: keyof t_order;
}

const sortable_headers = (show_free_zone_loader: boolean): sortable_header[]=>[
  {content: 'Qty', field: 'ips_amount'},
  {content: 'Creation Date', field: 'start'},
  {content: 'Renewal Date', field: 'until'},
  {content: 'Bandwidth (GB)', field: 'usage_info'},
  {content: show_free_zone_loader ?
    <Fragment>
      Configuring proxies
      <span className={styles.dots_loader}></span>
    </Fragment>
    : 'Configured proxies', field: 'generated_proxies'},
];

interface i_order_table_head_props {
    headers: sortable_header[];
    sorted_field: keyof t_order;
    on_sort?: (h: sortable_header)=>void;
    order_token?: boolean;
    hide_actions?: boolean;
    render_header: (h: sortable_header)=>JSX.Element;
}
const Order_table_header = (props: i_order_table_head_props)=>{
    const {headers, sorted_field, on_sort, order_token, hide_actions,
        render_header} = props;
    return <thead>
      <tr>
        {headers.map(h=>
          <th className={cn(styles.header_sorting,
            sorted_field==h.field&&styles.sorted_header)}
            key={h.field} onClick={()=>on_sort?.(h)}>
            {render_header(h)}
          </th>
        )}
        {order_token && <th>Order token</th>}
        {!hide_actions && <th className={styles.table_actions}></th>}
      </tr>
    </thead>;
};

export const Plan_table = (props:i_table_plan_props)=>{
    const {set} = use_pathname();
    const {set_qs} = use_qs_with_set();
    const {items, type, title, orders_count, is_free_zone_creating,
      need_login, with_onboarding, wrapper_cn,
      enable_sorting, hide_actions_col, show_recently_expired,
      show_config_caption = 'Show configured list'} = props;
    const {onboarding, set_onboarding} = use_onboarding();
    const {dashboard} = use_app_context();
    const {dispatch} = dashboard;
    const {theme} = use_theme();
    const [order_to_cancel, set_order_to_cancel] = useState<t_order>(null);
    const history = useHistory();
    const [show_error, set_show_error] = useState(false);
    const visible_orders = use_active_orders(items, show_recently_expired);
    const {sorting_state, set_sorting, sorted_orders} = use_sorting(
      props.enable_sorting, visible_orders);
    const {sorted_field} = sorting_state;
    const {visible: copied, show: show_copied} = use_disappear(3);
    const renew_update_cc = (order: t_order)=>{
        storage.set('renew_update_cc_orig', location.pathname);
        history.push(get_payment_renew_url(order));
    };
    const on_renew_enable = (order: t_order)=>etask(function*(){
        const res = yield api.update_auto_renewal(order._id, true);
        if (res.ok)
        {
            dispatch({type: 'refresh_orders'});
            history.push(`/dashboard/page/plans`
                +`?notification=auto_renew_success`);
            return;
        }
        if (order.is_legacy)
            renew_update_cc(order);
    });
    const {state: renew_state} = use_etask<[t_order]>(on_renew_enable);
    const show_config_list = (id: string)=>{
        set({configure_proxy: id, type});
        set_onboarding(ONBOARD_EVENTS.configured_list);
    };
    const [shown_free_config, set_shown_free_config] = useState(false);
    useEffect(()=>{
        if (!shown_free_config && visible_orders.some(o=>o._id == 'free_fake'))
        {
            setTimeout(()=>{
                set_shown_free_config(true);
                show_config_list('free_fake');
            }, 500);
        }
    }, [visible_orders, shown_free_config]);
    if (visible_orders.length===0)
      return null;
    const show_free_zone_badge = visible_orders.length==1 &&
        visible_orders[0].free_zone && orders_count == 1;
    const always_show_buttons = orders_count == 1;
    const show_onboarding = with_onboarding && show_free_zone_badge &&
        !onboarding.configured_list;
    const show_free_proxy_ready = show_free_zone_badge && show_onboarding;
    const show_free_zone_loader = visible_orders?.[0]?._id == 'free_fake' &&
        is_free_zone_creating;
    const handle_copy = (item: t_order)=>e=>{
        e.stopPropagation();
        void navigator.clipboard.writeText(item.client_id);
        show_copied();
    };
    const on_keep_renewal = ()=>set_order_to_cancel(null);
    const on_confirm_cancel = ()=>{
      etask(function*(){
        try {
          const res = yield fetch('/users/payment/update_auto_renewal'
            +'?no_redirect=1', {
              method: 'POST',
              json: true,
              body: {zone_id: order_to_cancel._id, auto_renew: false},
          });
          perr({id: 'toolip_cancel_subscription_from_dashboard',
            info: {err: res?.result?.error, ok: res=='ok'}
          });
          dispatch({type: 'refresh_orders'});
        } catch(e){
          console.error(e);
          set_show_error(true);
        } finally {
          set_order_to_cancel(null);
        }
      });
    };
    const is_toolip = www_hola.site == 'toolip';
    return <div className={cn(styles.table_wrapper, wrapper_cn)}>
      <Modal is_open={!!order_to_cancel} on_close={on_keep_renewal} portal
        cls={styles.cancelation_popup} width={300} no_logo>
        <p className={cn(theme.p3, theme.med,
          styles.cancelation_popup_text)}>
          Are you sure you want to cancel
          the auto-renewal of your plan?
        </p>
        <div className={styles.cancelation_popup_buttons}>
          <Button
            on_click={on_confirm_cancel}
            caption="Cancel"
            color="white"
            size="md" round={false}/>
          <Button
            on_click={on_keep_renewal}
            caption="Keep"
            color="black"
            size="md" round={false}/>
        </div>
      </Modal>
      <Modal is_open={!!show_error} on_close={()=>set_show_error(false)}
        cls={styles.cancelation_popup} width={300} no_logo>
        <p className={cn(theme.p3, theme.med, styles.error_popup_text)}>
          Something goes wrong during subscription cancellation,
          please try again later or contact our <a
          href="mailto:support@toolip.io">support team</a>
        </p>
        <div className={styles.cancelation_popup_buttons}>
          <Button
            on_click={()=>set_show_error(false)}
            caption="OK"
            color="white"
            size="md" round={false}/>
        </div>
      </Modal>
      <Table_header title={
        <Fragment>
          {title}
          {show_free_zone_badge && <span className={cn(styles.badge,
            theme.mono14)}>
            Free plan!
          </span>}
        </Fragment>}
        buttons={props.buttons} />
      <table className={cn(styles.plan_table,
        enable_sorting && visible_orders.length>1 && styles.with_sorting)}>
        <Order_table_header
          sorted_field={sorted_field}
          on_sort={h=>set_sorting(h.field)}
          order_token={props.show_order_token}
          hide_actions={hide_actions_col}
          headers={sortable_headers(show_free_zone_loader)}
          render_header={h=><span className={sorting_cn(h, sorting_state)}>
            {h.content}</span>}
        />
        <tbody>
          {sorted_orders?.map((item: t_order)=>{
            const usage = get_usage_info(item);
            const first_col = item.unit=='ip'
                ? `${item.ips_amount} prox${item.ips_amount > 1 ? 'ies':'y'}`
                : usage.limit_label;
            const is_new = item.user_state?.is_new && !show_free_zone_badge;
            const is_disabled_due_to_cb =
                item?.disabled?.reason == 'disabled_as_dispute_created';
            const visible_actions = props.get_visible_action?.(item)
                ?? get_visible_actions(item);

            const generate_proxies = ()=>{
                set({configure_proxies: item._id, type});
                if (item.unit=='gb')
                    set_qs({example: '1'});
            };
            const buy_plan = ()=>
                history.push(`/pricing/checkout?plan_id=${item.plan_id}`);
            const single_action = item._id == 'free_fake' ?
                is_free_zone_creating ? undefined
                : need_login
                : props.hide_actions && props.toggle_active
                ? ()=>props.toggle_active(item)
                : item.expired_recently ? buy_plan
                : visible_actions.update_payment
                ? ()=>props.update_payment?.(item)
                : visible_actions.config_list === visible_actions.generate
                ? undefined
                : visible_actions.config_list ? ()=>show_config_list(item._id)
                : generate_proxies;
            const row_cls = cn(single_action && styles.single_action,
                props.hide_actions && item._id==props.active?._id
                && styles.active,
                item.expired_recently && styles.expired,
                order_has_renew_error(item) && styles.error,
                is_disabled_due_to_cb && is_toolip &&
                styles.tr_disabled_due_to_cb);
            return <Fragment key={item._id}>
              <Order_row
                single_action={single_action}
                row_cls={row_cls}
                sorted_field={sorted_field}
                cols={{
                  qty: <>
                    {is_new && <New_badge/>}
                    {!is_disabled_due_to_cb && first_col}
                    {item.free_zone && <Free_badge/>}
                    {is_disabled_due_to_cb &&
                      <Disabled_due_to_chargeback qty={first_col}/>}
                  </>,
                  start: date_fmt(item.start),
                  end: <>
                    {props.render_subscr_end?.(item) ??
                      <Subscr_expiration order={item}
                        renew_state={renew_state}
                        on_update_cc={renew_update_cc}
                        refresh_orders={()=>dispatch({type: 'refresh_orders'})}
                      />
                    }
                  </>,
                  usage: <>
                    {props.render_bandwidth_info?.(item) ??
                      <Bandwidth_info type={type} order={item}
                        only_free_zone_visible={orders_count==1} />}
                  </>,
                  proxies: <>
                    {props.render_usage_info?.(item, is_free_zone_creating) ??
                      <Proxies_usage_info order={item}
                        show_loader={is_free_zone_creating}/>}
                  </>,
                  token: props.show_order_token &&
                    <Tooltip
                      content={
                        <span className={styles.copy_text}
                          onClick={handle_copy(item)}>
                            {copied ? 'Copied' : 'Copy'}
                            {copied ? <Icon_check/> : <Icon_copy/>}
                        </span>
                      }
                      hover_mode={true}
                      fast={true}
                      cls_cn={styles.copy_tooltip}>
                      <span
                        onClick={handle_copy(item)}>
                          {item.client_id}
                      </span>
                  </Tooltip>,
                  actions: !hide_actions_col && <>
                    {item._id == 'free_fake' &&
                      <Skeleton_loader is_loading={is_free_zone_creating}>
                        <Button caption={show_config_caption}
                          on_click={need_login}
                          cls={styles.onboarding_list_free_btn}
                          color={'transparent'} size={'xs'} round={false}/>
                      </Skeleton_loader>}
                    {item._id != 'free_fake' &&
                      <div className={cn(styles.table_actions_block,
                        show_onboarding && styles.show_onboarding,
                        (visible_actions.update_payment
                          || item.expired_recently
                          || always_show_buttons)
                        && styles.always_show_buttons)}>
                        {show_free_proxy_ready ?
                          <Free_proxy_ready
                            show_config_list={()=>show_config_list(item._id)}
                            show_config_caption={show_config_caption}
                            set_onboarding={set_onboarding}/> :
                          visible_actions.config_list && !props.hide_actions &&
                            <Button caption={
                              <Fragment>
                                {show_config_caption}
                              </Fragment>}
                              on_click={()=>show_config_list(item._id)}
                              color={'transparent'} size={'xs'} round={false}
                            />}
                        {visible_actions.buy_new && !props.hide_actions &&
                        <Button caption='Buy new plan'
                          on_click={buy_plan}
                          color={'black'} size={'xs'} round={false}
                        />}
                        {visible_actions.update_payment &&
                          !props.hide_actions &&
                          <Button caption='Update payment method'
                            on_click={()=>props.update_payment
                              ? props.update_payment(item)
                              : renew_update_cc(item)}
                            color={'black'} size={'xs'} round={false}
                          />}
                        {visible_actions.generate && !props.hide_actions &&
                        <Button caption={'Generate proxy'}
                          on_click={generate_proxies}
                          color={'black'} size={'xs'} round={false}
                          />}
                        {props.render_plan_popup_actions?.(item)}
                        {/* {props.render_plan_popup_actions
                          ? props.render_plan_popup_actions(item)
                          : !item.free_zone &&
                            <Action_menu
                              item_cls={theme.p3}
                              position={'left'} items={[
                              !item.subscription_cancelled && {
                                id: 'cancel_renewal',
                                text: 'Cancel plan renewal',
                                icon: Icon_payment_cancel,
                                on_click: ()=>on_cancel_renewal(item)},
                            ].filter(Boolean)}/>} */}
                      </div>}
                  </>,
                }}
              />
              <Extra_packages extra={usage.extra} order={item}
                render_bandwidth_info={
                  (o, u)=>props.render_bandwidth_info?.(o, u, true) ??
                  <Bandwidth_info type={type} order={o}
                    only_free_zone_visible={orders_count==1}/>
                }
              />
            </Fragment>;
          })}
        </tbody>
    </table>
  </div>;
};


interface i_extra_packages_props {
    order?: t_order;
    group?: t_zone_group;
    extra: ReturnType<typeof get_usage_info>['extra'];
    hidden?: boolean;
    render_bandwidth_info?: t_render_order_bw_info;
    render_group_bandwidth_info?: t_render_group_bw_info;
}
const Extra_packages = (props: i_extra_packages_props)=>{
    const {theme} = useContext(Settings_context);
    const {extra, order, group, render_bandwidth_info,
        render_group_bandwidth_info, hidden} = props;
    if (!extra || !order && !group)
        return null;
    const active_packages = extra.filter(d=>!d.is_full_usage);
    const visible_packages = (group||order).user_state?.hide_used_extra_limits
        ? active_packages : extra;
    return <>{visible_packages.map((d, i, all)=>{
      const Icon_cmp = i==all.length-1 ? Icon_extra_one : Icon_extra_mid;
      const size_cls = cn(styles.extra_size,
        !d.is_full_usage && styles.active);
      const is_warn = i==0 && (active_packages.length==0
        || active_packages.length==1 && active_packages[0].is_warn_usage);
      return <Extra_row key={d.start+i} hidden={hidden}
        cols={{
          size: <div className={size_cls}>
            {<Icon_cmp/>}
            <span className={styles.content_debug}>
              {d.size_label}
              {<Tooltip hover_mode fast cls_cn={styles.add_on_explanation_cn}
                cls={styles.add_on_explanation} content={
                  <>
                    <p className={cn(theme.p14, theme.bold, theme.color_n700,
                      styles.add_on_explanation_title)}>
                      Add-on plans
                    </p>
                    <p className={cn(theme.p12, theme.color_n600)}>
                      Add-on plans don't renew, but unused data rolls over to
                      your next subscription period. For example,
                      if you purchase
                      50GB and use 40GB, the remaining 10GB will carry over to
                      your next cycle.
                    </p>
                  </>
              }>
                <span className={styles.addon}>Add-On Plan</span>
              </Tooltip>}
            </span>
          </div>,
          start: <>{date_fmt(d.start)}</>,
          usage: <>
            {d.is_full_usage && !is_warn
              ? <span className={cn(styles.bandwidth_info)}>
                <Pie_chart percentage={d.percent_number}
                  is_full_color
                />
                {d.percent}
              </span>
              : group ? render_group_bandwidth_info?.(group,
                {...d, is_warn_usage: is_warn})
              : render_bandwidth_info?.(order,
                {...d, is_warn_usage: is_warn, is_extra_row: true})
            }
          </>,
        }} spent={d.is_full_usage && !is_warn}/>;
    })}</>;
};

type t_order_cols = 'qty' | 'start' | 'end' | 'usage' | 'proxies'
    | 'token' | 'actions';
interface i_order_row_props {
    single_action?: ()=>void;
    row_cls?: string;
    sorted_field?: string;
    cols?: Partial<Record<t_order_cols, ReactNode>>;
}
const Order_row = (props: i_order_row_props)=>{
    const {single_action, row_cls, sorted_field,
        cols = {} as i_order_row_props['cols']} = props;
    return <tr onClick={single_action}
      className={cn(styles.order_row, row_cls)}>
      <td className={cn(sorted_field=='ips_amount'
        && styles.sorted_column)}>{cols.qty}</td>
      <td className={cn(sorted_field=='start'
        && styles.sorted_column)}>{cols.start}</td>
      <td className={cn(sorted_field=='until'
        && styles.sorted_column)}>{cols.end}</td>
      <td className={cn(styles.table_data_usage,
        sorted_field=='usage_info' && styles.sorted_column)}>
        {cols.usage}</td>
      <td className={cn(sorted_field=='generated_proxies'
        && styles.sorted_column)}>{cols.proxies}</td>
      {cols.token && <td>{cols.token}</td>}
      {cols.actions && <td className={styles.table_actions}>
        {cols.actions}</td>}
    </tr>;
};

type t_group_zone_cols = 'name' | 'usage' | 'actions' | 'token';
interface i_group_zone_row {
    row_cls?: string;
    cols?: Partial<Record<t_group_zone_cols, ReactNode>>;
    deactivated?: boolean;
    single_action?: ()=>void;
}
const Group_order_row = (props: i_group_zone_row)=>{
    const {cols, row_cls, deactivated, single_action} = props;
    const {visible: copied, show: show_copied} = use_disappear(3);
    const handle_copy = (v: string)=>e=>{
        e.stopPropagation();
        void navigator.clipboard.writeText(v);
        show_copied();
    };
    return <tr className={cn(styles.group_order_row,
      deactivated && styles.deactivated, row_cls)}
      onClick={single_action}>
      <td colSpan={3}>
        {cols.name}
        {deactivated&&<span className={styles.badge_disabled}>Disabled</span>}
      </td>
      <td>{cols.usage}</td>
      {cols.token && <>
        <td></td>
        <td><Tooltip
          content={
            <span className={styles.copy_text}
              onClick={handle_copy(cols.token as string)}>
                {copied ? 'Copied' : 'Copy'}
                {copied ? <Icon_check/> : <Icon_copy/>}
            </span>
          }
          hover_mode={true}
          fast={true}
          cls_cn={styles.copy_tooltip}>
          <span onClick={handle_copy(cols.token as string)}>
            {cols.token}
          </span>
        </Tooltip></td>
      </>}
      <td colSpan={2} className={styles.table_actions}>{cols.actions}</td>
    </tr>;
};

type t_extra_row_cols = 'size' | 'start' | 'usage';
interface i_extra_row_props {
    row_cls?: string;
    cols?: Partial<Record<t_extra_row_cols, ReactNode>>;
    spent?: boolean;
    hidden?: boolean;
}
const Extra_row = (props: i_extra_row_props)=>{
    const {cols, row_cls, spent, hidden} = props;
    const cls = cn(styles.extra_row, spent && styles.spent, row_cls,
        hidden && styles.hidden);
    return <tr className={cls}>
      <td className={styles.size}>{cols.size}</td>
      <td colSpan={2}>{cols.start}</td>
      <td colSpan={4}>{cols.usage}</td>
    </tr>;
};

const sorting_cn = (h: sortable_header, sorting_state: i_sorting_state)=>{
    return cn(styles.header_cell,
        sorting_state.sorted_field == h.field
        && (sorting_state.is_asc ? styles.sorted_asc : styles.sorted_desc));
};

interface i_bandwidth_info_props {
    type: Proxy_type;
    order: t_order;
    only_free_zone_visible: boolean;
}

const Bandwidth_info = (props: i_bandwidth_info_props)=>{
    const {type, order, only_free_zone_visible} = props;
    const usage = get_usage_info(order);
    const {theme} = useContext(Settings_context);
    const {width} = use_screen();
    if (order.free_zone && usage.is_full_usage)
    {
        return width >= 768 ? <Popup show_on_hover position="bottom"
          popup_cls={styles.bandwidth_info_popup}
          wrapper_cls={styles.bandwidth_wrapper}
          is_always_shown={only_free_zone_visible}
          button_text={
            <span className={cn(styles.bandwidth_info, theme.color_n600)}>
              <Pie_chart percentage={usage.percent_number}
                is_warn_color={usage.is_warn_usage}/>
              {usage.percent}
            </span>}>
            <Bandwidth_free_full_popup/>
        </Popup> :
        <span className={cn(styles.bandwidth_info)}>
          <Pie_chart percentage={usage.percent_number}
            is_warn_color={usage.is_warn_usage}/>
          {usage.percent}
        </span>;
    }
    if (!order.free_zone && (type == 'isp_plus' || type == 'isp'))
    {
        return <span className={styles.tooltip}
          data-tt="Need more Bandwidth? No problem.
          When we say Unlimited, we mean it. On the house!">
          unlimited</span>;
    }
    return <span className={cn(styles.tooltip, styles.bandwidth_info)}
      data-tt={`${usage.used_label} out of ${usage.limit_label}`}>
      <Pie_chart percentage={usage.percent_number}
        is_warn_color={usage.is_warn_usage || order_has_renew_error(order)}/>
      {usage.percent}
    </span>;
};

interface i_group_bw_info_props {
    group: t_zone_group;
}
const Group_bandwidth_info = (props: i_group_bw_info_props)=>{
    const {group} = props;
    if (!group)
        return null;
    const usage = get_group_usage_info(group);
    return <span className={cn(styles.tooltip, styles.bandwidth_info)}
      data-tt={`${usage.used_label} out of ${usage.limit_label}`}>
      <Pie_chart percentage={usage.percent_number}
        is_warn_color={usage.is_warn_usage} />
      {usage.percent}
    </span>;
};

const Free_proxy_ready = ({show_config_caption, show_config_list,
set_onboarding})=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.free_proxy_ready_container}>
      <Popup position="bottom" is_always_shown={true}
        popup_cls={styles.free_proxy_ready_popup}
        wrapper_cls={styles.free_proxy_ready_wrapper}
        button={
          <Button caption={<Fragment>{show_config_caption}</Fragment>}
            on_click={()=>{
              show_config_list();
              set_onboarding('configured_list');
            }}
            color={'transparent'} size={'xs'} round={false}
          />}>
        <div className={cn(styles.free_proxy_ready)}>
          <div>
            <Icon_free_proxy_ready/>
          </div>
          <p className={cn(theme.p14, theme.med, theme.color_n700)}>
            Your free proxy is all set!
          </p>
          <p className={cn(theme.p12, theme.color_n500)}>
            Open the configuration to get the host, port, password, and
            username details
          </p>
        </div>
      </Popup>
    </div>;
};

export const Bandwidth_free_full_popup = ()=>{
    const {theme} = useContext(Settings_context);
    return <div className={cn(styles.bandwidth_popup, styles.free_full)}>
      <Icon_free_full/>
      <div className={styles.free_full_content} tabIndex={0}>
        <div>
          <p className={cn(theme.p16, theme.med, theme.color_n700,
            styles.mb8)}>
            Seems like you're all done with this one!
          </p>
          <p className={cn(theme.p14, theme.color_n500)}>
            Check out our flexible plans to find the best plan for
            your budget and needs
          </p>
        </div>
        <Button to={'/dashboard/page/pricing'} caption="Choose a plan"
          color="black" size="sm" round={false}/>
      </div>
    </div>;
};

const Proxies_usage_info = ({order, show_loader}:
    {order: t_order; show_loader: boolean;})=>{
    if (order.unit == 'gb')
        return <>unlimited</>;
    const proxies = order.generated_proxies?.
        filter(p=>!is_type_with_manual_proxies(order.type) ||
            p.manually_changed) ?? [];
    const usage_percent = `${proxies.length*100/order.ips_amount}%`;
    return <Skeleton_loader is_loading={show_loader}>
      <span className={cn(styles.ips_tooltip)}>
        <Proxies_countries_tooltip proxies={proxies} />
        <span className={styles.progressbar}>
          <span className={styles.progressbar_res}
            style={{width: usage_percent}} />
        </span>
        {`${proxies.length}/${order.ips_amount}`}
      </span>
    </Skeleton_loader>;
};

const Disabled_due_to_chargeback = ({qty})=>{
    const {theme} = useContext(Settings_context);
    const ref = useRef<LintHTMLDialogElement>(null);
    const {width} = use_screen();
    const is_mobile = width < 768;
    const is_oculus = www_hola.site == 'oculus';
    const on_close = ()=>ref?.current.close();
    const support_mail = `mailto:support@${is_oculus ?
        'oculusproxies.com' : 'toolip.io'}`;
    return <span className={is_oculus ?
      styles.disabled_due_to_cb_oc : styles.disabled_due_to_cb_tl}>{qty}
        <Popup position='bottom' show_on_hover={!is_mobile} popup_ref={ref}
          on_toggle={e=>e.stopPropagation()}
          popup_cls={styles.disabled_due_to_cb_popup}
          button_text={<p className={cn(theme.p10,
            is_oculus && cn(theme.color_n700, theme.med))}>
            Pending chargeback{is_mobile && !is_oculus && ' decision'}</p>}
          button_cls={styles.disabled_cb_btn}>
          <div className={styles.disabled_cb_container}>
            {is_mobile && <div className={styles.disabled_cb_popup_close}
              onClick={on_close}>{is_oculus ?
              <Icon_close24 /> : <Icon_close16 />}</div>}
            <div className={styles.freeze_icon}>
              <Icon_freeze />
            </div>
            <p className={cn(theme.color_n700, is_oculus ?
              cn(theme.p16, theme.bold) : cn(theme.p14, theme.med))}>
              Your Plan is Temporarily Frozen
            </p>
            <span className={styles.disabled_cb_explanation}>
              <p className={is_oculus ? theme.p14 : theme.p12}>
                We've temporarily frozen your plan due to a payment dispute
                associated with your account.
              </p>
              <p className={is_oculus ? theme.p14 : theme.p12}>
                If you have any questions or believe this is a mistake, please
                contact our support team for assistance.
              </p>
            </span>
            <a href={support_mail} className={styles.contact_support}>
              Contact support
            </a>
          </div>
        </Popup>
    </span>;
};

const Proxies_countries_tooltip = ({proxies}:
  {proxies?: t_generated_proxy[]})=>{
    if (!proxies || proxies.length == 0)
        return <></>;

    const dict = proxies.reduce((a, c)=>{
      a[c.country] = (a[c.country] ?? 0) + 1;
      return a;
    }, {});

    return <span className={styles.ips_tooltip_container}>
      <span className={styles.ips_tooltip__header}>Qty</span>
      <span className={styles.ips_tooltip__header}>Country</span>
      {Object.entries(dict).map(([country, count])=>{
        return <Fragment key={country}>
          <span>{count as number}</span>
          <span><Flag country={country} size={16} round />
            {get_country_object(country)?.name}</span>
        </Fragment>;
      })}
    </span>;
};

interface table_header_props {
    title: string | React.ReactNode,
    subtitle?: React.ReactNode,
    buttons: React.ReactNode,
}

 export const Table_header = (props: table_header_props)=>{
    const {theme} = useContext(Settings_context);
    const {title, buttons, subtitle} = props;
    return (
      <div className={cn(styles.table_header_container)}>
        <p className={cn(styles.table_header, theme.med)}>
            {title}
            {subtitle}
        </p>
        <div className={styles.table_header_buttons}>
            {buttons}
        </div>
      </div>
    );
};

const group_zone_names: Partial<Record<Proxy_type, string>> = {
    [Proxy_type.EV_RES]: 'Tickets',
    [Proxy_type.SNK]: 'Sneakers',
};

interface i_group_table_props {
    group: t_zone_group;
    title: string | React.ReactNode;
    wrapper_cn: string
    multiple_zones?: boolean;
    show_order_token?: boolean;
    render_bandwidth_info?: t_render_group_bw_info;
    render_subscr_end?: (group: t_zone_group)=>JSX.Element;
    is_disabled_no_kyc_start?: boolean;
}
export const Group_table = (props: i_group_table_props)=>{
    const {group, multiple_zones = true, show_order_token,
        render_bandwidth_info, is_disabled_no_kyc_start} = props;
    const {set} = use_pathname();
    const {set_qs} = use_qs_with_set();
    const {theme} = use_theme();
    const [expanded, set_expanded] = useState(false);
    const toggle = ()=>set_expanded(v=>!v);
    const [zone_to_close, set_zone_to_close] = useState<t_order>(null);
    const [show_uc_modal, set_show_uc_modal] = useState(false);
    const {kyc, dashboard} = use_app_context();
    const on_cancel_zone_close = ()=>{
        set_zone_to_close(null);
    };
    const on_confirm_zone_close = ()=>{
        etask(function*(){
            try {
                const res = yield fetch('/api/groups/zone/deactivate',
                  {method: 'PUT', body:
                      {group_id: group._id, zone_id: zone_to_close?._id}});
                if (!res?.deactivated)
                    throw new Error(`deactivate_zone is not ok: ${res}`);
                perr({id: 'toolip_deactivate_zone_from_dashboard'});
            } catch(e){
                console.error(e);
            } finally {
                dashboard.dispatch({type: 'refresh_orders'});
                set_zone_to_close(null);
            }
        });
    };
    const show_zone_menu = use_debug_ui('group_zone_menu');
    const group_extra_debug = use_debug_ui('group_extra');
    const show_group_extra = group && (group_extra_debug
        || www_hola.dashboard_group_extra_limits);
    if (!group)
        return null;
    const usage = get_group_usage_info(group);
    const is_kyc_rejected = group.type == 'events_resi_group'
        && (kyc.info.status == 'rejected' || is_disabled_no_kyc_start);
    const can_add_zone = !is_group_expired(group)
        && (multiple_zones || !group.zones?.length)
        && !is_kyc_rejected;
    const config_new_zone = ()=>set({configure_group: group._id});
    const add_zone = ()=>{
        if (group.enable_additional_usage_charges || !show_zone_menu)
            config_new_zone();
        else
            set_show_uc_modal(true);
    };
    const show_config_list = (id: string, type: Proxy_type)=>{
        set({configure_proxy: id, type, zone_group: group._id});
    };
    const show_generate_proxies = (id: string, type: Proxy_type)=>{
        set({configure_proxies: id, type});
        set_qs({example: '1'});
    };
    const single_action = ()=>toggle();
    const wrapper_cls = cn(styles.table_wrapper, props.wrapper_cn);
    const table_cls = cn(styles.group_table, expanded && styles.expanded,
        is_kyc_rejected && styles.disabled);
    const first_row_cls = cn(styles.group_first_row,
        single_action && styles.single_action);
    return <div className={wrapper_cls}>
      <Modal is_open={!!zone_to_close} on_close={on_cancel_zone_close} portal
        cls={styles.zone_close_popup} width={420} no_logo>
        <p className={cn(theme.p16, theme.med, styles.title)}>
          Confirm Zone Closure</p>
        <p className={cn(theme.p14, theme.med, styles.text)}>
          Closing this zone is a permanent action and cannot be undone. Once
          closed, this zone will be disabled and remain visible for
          reference only.
          <br/>Are you sure you want to proceed?
        </p>
        <div className={styles.cancelation_popup_buttons}>
          <Button
            on_click={on_cancel_zone_close}
            caption="Cancel"
            color="white"
            size="md" round={false}/>
          <Button
            on_click={on_confirm_zone_close}
            caption="Close permanently"
            color="black"
            size="md" round={false}/>
        </div>
      </Modal>
      <Usage_charges_modal is_open={show_uc_modal}
        on_close={()=>{ set_show_uc_modal(false); }}
        group={group} on_confirm={config_new_zone} portal
      />
      <Table_header title={<Fragment>{props.title}</Fragment>}
        buttons={null}
        subtitle={<Maybe_kyc_subtitle type={group.type}
          is_disabled_no_kyc_start={is_disabled_no_kyc_start}/>}
      />
      <table className={table_cls}>
        <Order_table_header
          sorted_field={'until'}
          order_token={show_order_token}
          hide_actions={false}
          headers={sortable_headers(false)}
          render_header={h=><span className={sorting_cn(h, {
            is_sorted: false,
            sorted_field: null,
            is_asc: true
          })}>{h.content}</span>}
        />
        <tbody>
          <Order_row
            single_action={single_action}
            row_cls={first_row_cls}
            cols={{
              qty: <>{convert_byte_to_gb(group.limit)} Gb</>,
              start: date_fmt(group.start),
              end: props.render_subscr_end?.(group) ?? date_fmt(group.until),
              usage: <>
                {render_bandwidth_info?.(group) ??
                  <Group_bandwidth_info group={group}/>}
              </>,
              ...show_order_token && {token: <></>},
              proxies: <>Unlimited</>,
              actions: <div className={cn(styles.action_buttons,
                expanded && styles.expanded)}>
                {can_add_zone && <Button caption={'Add zone'}
                  on_click={add_zone} color={'black'} size={'xs'}
                  round={false} cls={styles.group_add_btn}
                />}
                {group.zones?.length > 0 && <Icon_chevron_down width={24}
                  height={24}/>}
              </div>,
            }}
          />
          {show_group_extra && <Extra_packages extra={usage.extra}
            group={group} render_group_bandwidth_info={render_bandwidth_info}
            hidden={!expanded}
          />}
          {group.zones?.map((item: t_order, index)=>{
            const {used} = get_usage_data(item);
            const show_item_config = (ev?: any)=>{
                ev?.stopPropagation();
                show_config_list(item._id, item.type);
            };
            const generate_proxies = (ev?: any)=>{
                ev?.stopPropagation();
                show_generate_proxies(item._id, item.type);
            };
            const gb_used = convert_byte_to_gb(used).toFixed(2);
            return <Fragment key={item._id}>
              <Group_order_row
                row_cls={!expanded && styles.hidden}
                deactivated={!!item.next_zone_id}
                cols={{
                  name: `Zone ${index+1} - ${group_zone_names[item.type]}`,
                  usage: `${gb_used}GB used`,
                  token: show_order_token && item.client_id,
                  actions: !item.next_zone_id &&
                    <div className={styles.action_buttons}>
                      <Button
                        caption={'Configured list'}
                        on_click={show_item_config} color={'transparent'}
                        size={'xs'} round={false}
                      />
                      <Button caption={'Generate proxy'}
                        on_click={generate_proxies} color={'black'}
                        size={'xs'} round={false}
                      />
                      {show_zone_menu && <Action_menu
                        popup_cls={styles.group_action_menu_popup}
                        item_cls={styles.group_menu_item}
                        position={'left'} items={[{
                          id: 'close_zone',
                          text: 'Close zone',
                          icon: ()=><Icon_trash_filled/>,
                          on_click: ()=>{
                            set_zone_to_close(item);
                          },
                        }]}
                      />}
                    </div>,
                }}
              />
            </Fragment>;
          })}
        </tbody>
    </table>
  </div>;
};
